package com.milta.feature.route.domain.entity

/** MIL-38 gap fix — [Untreated] mirrors [StopStatus.Untreated] (driver-side): set server-side on
 * stops still Pending when a route is force-completed (MIL-36). Previously collapsed into
 * [Pending] here, silently hiding this distinction from the Gestionnaire. */
enum class DeliveryStatus {
    Pending,
    Completed,
    Failed,
    Untreated,
}
